import { useState, useEffect } from "react";
import styles from "../../Jimson/ProjectLibrary/ComponentsForProjectLibrary/Filter.module.css";
import axios from "axios"; //alternative of fetch to request data from backend
import { useNavigate, useLocation } from "react-router-dom"; //use to change the current URL

//copied a code from Jimson's filter.js

export default function Filter() {
  const [projects, setProjects] = useState([]); //fetched data from the server
  const [filteredProjects, setFilteredProjects] = useState([]); //filtered data by category(General)
  const [courseFilter, setCourseFilter] = useState(null); //filtered data by "course" category
  const [limitFilter, setLimitFilter] = useState(null); //limits display filter
  //TODO:  checkbox filter group
  const [subscriptionFilter, setSubscriptionFilter] = useState([]); //filtered data by "subscription" category
  const [activityTypeFilter, setActivityTypeFilter] = useState([]); //filtered data by "activity type" category
  const [yearLevelFilter, setYearLevelFilter] = useState([]); //filtered data by "year level" category
  const [subjectMatterFilter, setSubjectMatterFilter] = useState([]); //filtered data by "subject matter" category
  //TODO: active state for buttons
  const [isBeginnerActive, setIsBeginnerActive] = useState(false);
  const [isIntermediateActive, setIsIntermediateActive] = useState(false);
  const [isAdvancedActive, setIsAdvancedActive] = useState(false);
  const [is5Active, setIs5Active] = useState(false);
  const [is10Active, setIs10Active] = useState(false);
  const [isAllActive, setIsAllActive] = useState(false);

  const navigate = useNavigate(); //useNavigate hook stored in constant variable
  const location = useLocation();

  //   //TODO: fetching data through API call  ===(line 46 - 53)       //params from line 28 - 44
  useEffect(() => {
    //useEffect being used to initiate the data fetching process
    const params = new URLSearchParams(location.search); //*used to extract and parse the query parameters

    const course = params.get("course"); //*used to retrieve the value of the query parameter in COURSE filtering
    if (course) {
      setCourseFilter(course);
      if (course === "Beginner") setIsBeginnerActive(true);
      if (course === "Intermediate") setIsIntermediateActive(true);
      if (course === "Advanced") setIsAdvancedActive(true);
    }

    const limit = params.get("limit"); //*used to retrieve the value of the query parameter in LIMIT filtering
    if (limit) {
      setLimitFilter(parseInt(limit));
      if (limit === "5") setIs5Active(true);
      if (limit === "10") setIs10Active(true);
      if (!limit) setIsAllActive(true);
    }
    //     //++++++
    axios
      .get("http://localhost:4000/api/projects/") //server API address where data being fetched
      .then((response) => {
        setProjects(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [location.search]);
  //   //TODO: ==========Filtered Data==========(line 56 - 84)------=useEffect(() => { ... },[])
  useEffect(() => {
    let filteredData = [...projects]; //using spread operator to get a copy of the "projects" array

    if (courseFilter) {
      filteredData = filteredData.filter((project) => project.course === courseFilter);
    }

    if (limitFilter) {
      filteredData = filteredData.slice(0, limitFilter);
    }

    if (subscriptionFilter.length > 0) {
      filteredData = filteredData.filter((project) => subscriptionFilter.includes(project.subscription));
    }

    if (activityTypeFilter.length > 0) {
      filteredData = filteredData.filter((project) => activityTypeFilter.includes(project.activity_type));
    }

    if (yearLevelFilter.length > 0) {
      filteredData = filteredData.filter((project) => yearLevelFilter.includes(project.year_level));
    }

    if (subjectMatterFilter.length > 0) {
      filteredData = filteredData.filter((project) => subjectMatterFilter.includes(project.subject_matter));
    }

    setFilteredProjects(filteredData);
  }, [
    projects,
    courseFilter,
    limitFilter,
    subscriptionFilter,
    activityTypeFilter,
    yearLevelFilter,
    subjectMatterFilter,
  ]); //state variables

  //   //TODO: ==========Updating State / Event Handler Function==========(line 69 - 113)
  const handleCourseFilter = (course) => {
    //course buttons handler
    setCourseFilter(course);
    setIsBeginnerActive(course === "Beginner"); //for active state effect for buttons
    setIsIntermediateActive(course === "Intermediate"); //active state ***
    setIsAdvancedActive(course === "Advanced"); //active state ***
    navigate(`/teacher-projects-library?course=${course}${limitFilter !== null ? `&limit=${limitFilter}` : ""}`);
  };

  const handleLimitFilter = (limit) => {
    //display limit buttons handler
    setLimitFilter(limit);
    setIs5Active(limit === 5); //for active state effect for buttons
    setIs10Active(limit === 10); //active state ***
    setIsAllActive(limit === null); //active state ***
    navigate(`/teacher-projects-library?course=${courseFilter}${limit !== null ? `&limit=${limit}` : ""}`);
  };

  const handleSubscriptionFilter = (subscription) => {
    //checkbox filter subscription category
    let updatedSubscriptionFilter;

    if (subscriptionFilter.includes(subscription)) {
      updatedSubscriptionFilter = subscriptionFilter.filter((item) => item !== subscription);
    } else {
      updatedSubscriptionFilter = [...subscriptionFilter, subscription];
    }
    setSubscriptionFilter(updatedSubscriptionFilter);

    const updatedParams = new URLSearchParams(location.search); //*updating url params for subscription category

    if (updatedSubscriptionFilter.length > 0) {
      updatedParams.set("subscription", updatedSubscriptionFilter.join(","));
    } else {
      updatedParams.delete("subscription");
    }

    navigate(`/teacher-projects-library${updatedParams.toString() ? `?${updatedParams.toString()}` : ""}`);
  };

  const handleActivityTypeFilter = (activityType) => {
    //checkbox filter activity type category
    let updatedActivityTypeFilter;

    if (activityTypeFilter.includes(activityType)) {
      updatedActivityTypeFilter = activityTypeFilter.filter((item) => item !== activityType);
    } else {
      updatedActivityTypeFilter = [...activityTypeFilter, activityType];
    }
    setActivityTypeFilter(updatedActivityTypeFilter);

    const updatedParams = new URLSearchParams(location.search); //*updating url params activity type category

    if (updatedActivityTypeFilter.length > 0) {
      updatedParams.set("activityType", updatedActivityTypeFilter.join(","));
    } else {
      updatedParams.delete("activityType");
    }

    navigate(`/teacher-projects-library${updatedParams.toString() ? `?${updatedParams.toString()}` : ""}`);
  };

  const handleYearLevelFilter = (...selectedYearLevels) => {
    const updatedYearLevelFilter = [...yearLevelFilter];

    selectedYearLevels.forEach((yearLevel) => {
      if (updatedYearLevelFilter.includes(yearLevel)) {
        updatedYearLevelFilter.splice(updatedYearLevelFilter.indexOf(yearLevel), 1);
      } else {
        updatedYearLevelFilter.push(yearLevel);
      }
    });
    setYearLevelFilter(updatedYearLevelFilter);

    const updatedParams = new URLSearchParams(location.search);

    if (updatedYearLevelFilter.length > 0) {
      updatedParams.set("yearLevel", updatedYearLevelFilter.join(","));
    } else {
      updatedParams.delete("yearLevel");
    }

    navigate(`/teacher-projects-library${updatedParams.toString() ? `?${updatedParams.toString()}` : ""}`);
  };

  const handleSubjectMatterFilter = (subjectMatter) => {
    let updatedSubjectMatterFilter;

    if (subjectMatterFilter.includes(subjectMatter)) {
      updatedSubjectMatterFilter = subjectMatterFilter.filter((item) => item !== subjectMatter);
    } else {
      updatedSubjectMatterFilter = [...subjectMatterFilter, subjectMatter];
    }
    setSubjectMatterFilter(updatedSubjectMatterFilter);

    const updatedParams = new URLSearchParams(location.search);

    if (updatedSubjectMatterFilter.length > 0) {
      updatedParams.set("subjectMatter", updatedSubjectMatterFilter.join(","));
    } else {
      updatedParams.delete("subjectMatter");
    }

    navigate(`/teacher-projects-library${updatedParams.toString() ? `?${updatedParams.toString()}` : ""}`);
  };

  return (
    <div className={styles.mainContainer}>
      {/* ==========Checkbox Section==========(line 120 - 248) */}
      <div className={styles.checkboxContainer}>
        <h4 className={styles.checkboxFilter}>SUBSCRIPTION</h4>
        <div className={styles.subscription}>
          <div>
            <input
              id="free" //id is used for htmlFor in label
              type="checkbox"
              onChange={() => handleSubscriptionFilter("Free")}
            />
            <label htmlFor="free" className={styles.labelWithSpace}>
              {" "}
              Free
            </label>
          </div>
          <div>
            <input id="premium" type="checkbox" onChange={() => handleSubscriptionFilter("Premium")} />
            <label htmlFor="premium" className={styles.labelWithSpace}>
              {" "}
              Premium
            </label>
          </div>
        </div>
        <br />

        <h4 className={styles.checkboxFilter}>ACTIVITY TYPE</h4>
        <div className={styles.activityType}>
          <div>
            <input id="animation" type="checkbox" onChange={() => handleActivityTypeFilter("Animation")} />
            <label htmlFor="animation" className={styles.labelWithSpace}>
              {" "}
              Animation
            </label>
          </div>
          <div>
            <input id="game" type="checkbox" onChange={() => handleActivityTypeFilter("Game")} />
            <label htmlFor="game" className={styles.labelWithSpace}>
              {" "}
              Game{" "}
            </label>
          </div>
          <div>
            <input id="chatbot" type="checkbox" onChange={() => handleActivityTypeFilter("Chatbot")} />
            <label htmlFor="chatbot" className={styles.labelWithSpace}>
              {" "}
              Chatbot{" "}
            </label>
          </div>
          <div>
            <input
              id="augmented reality"
              type="checkbox"
              onChange={() => handleActivityTypeFilter("Augmented Reality")}
            />
            <label htmlFor="augmented reality" className={styles.labelWithSpace}>
              {" "}
              Augmented Reality
            </label>
          </div>
        </div>
        <br />

        <h4 className={styles.checkboxFilter}>YEAR LEVEL</h4>
        <div className={styles.yearLevel}>
          <div>
            <input id="1 - 4" type="checkbox" onChange={() => handleYearLevelFilter(1, 2, 3, 4)} />
            <label htmlFor="1 - 4" className={styles.labelWithSpace}>
              {" "}
              1 - 4{" "}
            </label>
          </div>
          <div>
            <input id="5 - 6" type="checkbox" onChange={() => handleYearLevelFilter(5, 6)} />
            <label htmlFor="5 - 6" className={styles.labelWithSpace}>
              {" "}
              5 - 6{" "}
            </label>
          </div>
          <div>
            <input id="7 - 8" type="checkbox" onChange={() => handleYearLevelFilter(7, 8)} />
            <label htmlFor="7 - 8" className={styles.labelWithSpace}>
              {" "}
              7 - 8{" "}
            </label>
          </div>
          <div>
            <input id="9 - 13" type="checkbox" onChange={() => handleYearLevelFilter(9, 10, 11, 12, 13)} />
            <label htmlFor="9 - 13" className={styles.labelWithSpace}>
              {" "}
              9 - 13{" "}
            </label>
          </div>
        </div>
        <br />

        <h4 className={styles.checkboxFilter}>SUBJECT MATTER</h4>
        <div className={styles.subjectMatter}>
          <div>
            <input
              id="computer science"
              type="checkbox"
              onChange={() => handleSubjectMatterFilter("Computer Science")}
            />
            <label htmlFor="computer science" className={styles.labelWithSpace}>
              {" "}
              Computer Science{" "}
            </label>
          </div>
          <div>
            <input id="maths" type="checkbox" onChange={() => handleSubjectMatterFilter("Maths")} />
            <label htmlFor="maths" className={styles.labelWithSpace}>
              {" "}
              Maths{" "}
            </label>
          </div>
          <div>
            <input id="science" type="checkbox" onChange={() => handleSubjectMatterFilter("Science")} />
            <label htmlFor="science" className={styles.labelWithSpace}>
              {" "}
              Science{" "}
            </label>
          </div>
          <div>
            <input id="language" type="checkbox" onChange={() => handleSubjectMatterFilter("Language")} />
            <label htmlFor="language" className={styles.labelWithSpace}>
              {" "}
              Language{" "}
            </label>
          </div>
          <div>
            <input id="art" type="checkbox" onChange={() => handleSubjectMatterFilter("Art")} />
            <label htmlFor="art" className={styles.labelWithSpace}>
              {" "}
              Art{" "}
            </label>
          </div>
          <div>
            <input id="music" type="checkbox" onChange={() => handleSubjectMatterFilter("Music")} />
            <label htmlFor="music" className={styles.labelWithSpace}>
              {" "}
              Music{" "}
            </label>
          </div>
        </div>
        <br />
      </div>

      {/* ==========Buttons Section==========(line 251 - 263 ) */}
      <div className={styles.buttonsAndDisplayContainer}>
        <div className={styles.buttonsDiv}>
          <div className={styles.leftButtons}>
            <button
              id="display-beginner"
              onClick={() => handleCourseFilter("Beginner")}
              className={`${styles.filterBtn} ${styles.beginnerAnd5Btn} ${styles.leftButtonSize} ${
                isBeginnerActive ? styles.active : ""
              }`}
            >
              BEGINNER
            </button>
            <button
              id="display-intermediate"
              onClick={() => handleCourseFilter("Intermediate")}
              className={`${styles.filterBtn} ${styles.leftButtonSize} ${isIntermediateActive ? styles.active : ""}`}
            >
              INTERMEDIATE
            </button>
            <button
              id="display-advanced"
              onClick={() => handleCourseFilter("Advanced")}
              className={`${styles.filterBtn} ${styles.advancedAndAllBtn} ${styles.leftButtonSize} ${
                isAdvancedActive ? styles.active : ""
              }`}
            >
              ADVANCED
            </button>
          </div>
          <div className={styles.rightButtons}>
            <button
              id="display-5"
              onClick={() => handleLimitFilter(5)}
              className={`${styles.filterBtn} ${styles.beginnerAnd5Btn} ${styles.rightButtonSize} ${
                is5Active ? styles.active : ""
              }`}
            >
              5
            </button>
            <button
              id="display-10"
              onClick={() => handleLimitFilter(10)}
              className={`${styles.filterBtn}  ${styles.rightButtonSize} ${is10Active ? styles.active : ""}`}
            >
              10
            </button>
            <button
              id="display-all"
              onClick={() => handleLimitFilter(null)}
              className={`${styles.filterBtn} ${styles.advancedAndAllBtn} ${styles.rightButtonSize} ${
                isAllActive ? styles.active : ""
              }`}
            >
              All
            </button>
          </div>
        </div>
        <div className={styles.gridContainer}>
          {filteredProjects.map((project) => (
            <div key={project.project_id} className={styles.card}>
              <img src={project.project_pic} alt="img" />
              <p className={styles.titleCard} key={project.id}>
                {project.name}
              </p>
              <p className={styles.textCard}>
                {project.course.toUpperCase()} | {project.activity_type}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
